import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const CoinIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    fill="none"
    height={16}
    ref={ref}
    viewBox="0 0 16 16"
    width={16}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 2.3125C4.85888 2.3125 2.3125 4.85888 2.3125 8C2.3125 11.1411 4.85888 13.6875 8 13.6875C11.1411 13.6875 13.6875 11.1411 13.6875 8C13.6875 4.85888 11.1411 2.3125 8 2.3125Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.00366 4.08759C8.31556 4.08782 8.56795 4.34115 8.56806 4.65285V5.11308C9.14088 5.24234 9.56853 5.52413 9.75579 5.65785L9.75409 5.6587C9.78251 5.67723 9.80115 5.70278 9.81215 5.72701C9.824 5.75335 9.83106 5.78258 9.83435 5.81069C9.84089 5.86718 9.83579 5.934 9.8241 6.0011C9.80076 6.13489 9.74498 6.29154 9.66101 6.40498C9.5798 6.51448 9.45951 6.62085 9.33569 6.68847C9.21849 6.75242 9.06597 6.79858 8.94291 6.72775L8.93608 6.72348C8.84727 6.66172 8.68675 6.55696 8.49805 6.46817C8.35507 6.40094 8.1995 6.34436 8.04806 6.32045L7.89863 6.30764C7.74928 6.3077 7.65053 6.35345 7.58953 6.41438C7.52808 6.47579 7.49568 6.56176 7.4956 6.65858C7.4956 6.75177 7.55024 6.84707 7.69114 6.95914C7.83212 7.07116 8.04474 7.18775 8.32642 7.32375C8.67766 7.49416 9.09655 7.68262 9.42449 7.96671C9.7574 8.25519 9.99994 8.64514 10 9.21592C9.99984 9.94974 9.46376 10.6689 8.56806 10.8827V11.348C8.56806 11.66 8.31542 11.9122 8.00366 11.9124C7.69194 11.9123 7.4384 11.6602 7.4384 11.348V10.9032C6.72148 10.7885 6.30071 10.4749 6.13795 10.314C6.04444 10.2209 5.88844 9.91197 6.12344 9.50453C6.24287 9.29782 6.39831 9.20884 6.54269 9.18689C6.67733 9.16658 6.79742 9.20608 6.85862 9.24922C7.0901 9.4041 7.47948 9.67264 7.95242 9.67274C8.23982 9.6727 8.42291 9.49987 8.42291 9.28167C8.42274 9.14683 8.36399 9.03049 8.23591 8.9145C8.1049 8.79603 7.90597 8.68299 7.63905 8.55759L7.6382 8.55673C7.25339 8.36807 6.85225 8.16189 6.54866 7.87876C6.27993 7.62803 6.0858 7.31525 6.04147 6.90194L6.03207 6.71835C6.03223 6.00718 6.50994 5.29822 7.4384 5.09942V4.65285C7.43851 4.34098 7.6918 4.08773 8.00366 4.08759Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
));

CoinIcon.displayName = 'CoinIcon';

export default CoinIcon;
